import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import CreatePostButton from '../create-post-button';
import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { connect } from 'react-redux';

const NoPostsWriter = ({ category, t, shouldShowCreatePostButton, ...props }) => (
  <EmptyStates title={t('no-posts-writer.create-posts')} content={t('no-posts-writer.readers-would-love')} {...props}>
    {shouldShowCreatePostButton ? <CreatePostButton categorySlug={category && category.slug} /> : null}
  </EmptyStates>
);

NoPostsWriter.propTypes = {
  category: PropTypes.object,
  t: PropTypes.func,
  shouldShowCreatePostButton: PropTypes.bool,
};

const mapStateToProps = state => ({
  shouldShowCreatePostButton: !isOneApp(state),
});

export default flowRight(
  withTranslate,
  connect(mapStateToProps),
)(NoPostsWriter);
